import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap5';
import * as Yup from 'yup';
import { Formik, Form as FormikForm } from 'formik';

import Footer from 'components/Widgets/Profile/FormFooter';
import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';
import HorizontalSelectField from 'components/new_ui/Form/HorizontalSelectField';
import { useContext as useUsersContext } from 'components/Users/Context';
import Actions from 'components/Affiliates/Profile/Actions';

export default function General({ onCloseClick }) {
  const { dispatch: dispatchUsers, actions: actionsUsers, state: stateUsers } = useUsersContext();

  const affiliate = stateUsers.user.attributes.specific;

  const formSchema = Yup.object().shape({
    first_name: Yup.string().required('First Name is required'),
    last_name: Yup.string().required('Last Name is required'),
    affiliate_type: Yup.string().typeError('Type is required'),
  });

  const onSubmitHundler = (values, { setSubmitting, setErrors }) => {
    Actions.update(
      affiliate.id,
      values,
      true,
      () => {
        setSubmitting(false);
        onCloseClick();
        actionsUsers.load(dispatchUsers);
      },
      (errors) => {
        const newErrors = {};
        errors.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setSubmitting(false);
      },
    );
  };

  return (
    <Formik
      validationSchema={formSchema}
      initialValues={{
        first_name: affiliate.first_name,
        last_name: affiliate.last_name,
        affiliate_type: affiliate.affiliate_type,
        company_name: affiliate.company_name,
      }}
      onSubmit={onSubmitHundler}
    >
      {({ values, isSubmitting }) => (
        <FormikForm className="needs-validation" noValidate="">
          <Row>
            <Col lg={6}>
              <HorizontalTextField name="first_name" label="First Name" required />
            </Col>

            <Col lg={6}>
              <HorizontalTextField name="last_name" label="Last Name" required />
            </Col>
          </Row>

          <Row>
            <Col>
              <HorizontalSelectField
                className="select-counter-form"
                name="affiliate_type"
                label="Are you an independent affiliate or work for an insurance brokerage?"
                options={[
                  { value: 'broker', label: 'I am a broker.' },
                  { value: 'independent', label: 'I am an independent affiliate.' },
                ]}
                required
              />
            </Col>
          </Row>

          <Row>
            <Col>
              {values.affiliate_type === 'broker' && (
                <HorizontalTextField name="company_name" label="Company" />
              )}
            </Col>
          </Row>

          <Footer loading={isSubmitting} onCancel={() => onCloseClick()} />
        </FormikForm>
      )}
    </Formik>
  );
}

General.propTypes = {
  onCloseClick: PropTypes.func.isRequired,
};
